import { SCALE_LABELS, FONT_MAP } from '../../constants/defaults';
import useThemePreview from '../../hooks/useThemePreview';
import ScaleDisplay from './ScaleDisplay';
import CopyJsonButton from './CopyJsonButton';
import Button from '../ui/Button';
import './BriefCard.css';

export default function BriefCard({ brief, onEdit }) {
  const { cssVariables } = useThemePreview(brief);

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <div className="brief-card" style={cssVariables}>
      <div className="brief-card__header">
        <div className="brief-card__logo">
          {brief.brandCore.name.charAt(0).toUpperCase()}
        </div>
        <div className="brief-card__meta">
          <h1 className="brief-card__title">{brief.brandCore.name}</h1>
          <span className="brief-card__date">
            Created {formatDate(brief.createdAt)}
            {brief.updatedAt !== brief.createdAt && (
              <> · Updated {formatDate(brief.updatedAt)}</>
            )}
          </span>
        </div>
        <div className="brief-card__actions">
          <CopyJsonButton brief={brief} />
          {onEdit && (
            <Button variant="outline" size="sm" onClick={onEdit}>
              Edit
            </Button>
          )}
        </div>
      </div>

      <div className="brief-card__section">
        <h2 className="brief-card__section-title">Mission</h2>
        <p className="brief-card__mission">{brief.brandCore.mission}</p>
      </div>

      {brief.brandCore.vibeKeywords?.some(k => k && k.trim()) && (
        <div className="brief-card__section">
          <h2 className="brief-card__section-title">Vibe Keywords</h2>
          <div className="brief-card__keywords">
            {brief.brandCore.vibeKeywords.filter(k => k && k.trim()).map((keyword, i) => (
              <span key={i} className="brief-card__keyword">{keyword}</span>
            ))}
          </div>
        </div>
      )}

      <div className="brief-card__section">
        <h2 className="brief-card__section-title">Visual Identity</h2>
        <div className="brief-card__visuals">
          <div className="brief-card__visual-item">
            <span className="brief-card__visual-label">Accent Color</span>
            <div className="brief-card__visual-value brief-card__visual-value--color">
              <span 
                className="brief-card__color-swatch"
                style={{ backgroundColor: brief.visuals.colorSeed }}
              />
              <code>{brief.visuals.colorSeed.toUpperCase()}</code>
            </div>
          </div>
          <div className="brief-card__visual-item">
            <span className="brief-card__visual-label">Color Mode</span>
            <span className="brief-card__visual-value">
              {brief.visuals.colorMode === 'dark' ? '🌙 Dark' : '☀️ Light'}
            </span>
          </div>
          <div className="brief-card__visual-item">
            <span className="brief-card__visual-label">Typography</span>
            <span 
              className="brief-card__visual-value"
              style={{ fontFamily: FONT_MAP[brief.visuals.fontStyle] }}
            >
              {brief.visuals.fontStyle.charAt(0).toUpperCase() + brief.visuals.fontStyle.slice(1)}
            </span>
          </div>
        </div>
      </div>

      <div className="brief-card__section">
        <h2 className="brief-card__section-title">Design Scales</h2>
        <div className="brief-card__scales">
          <ScaleDisplay
            value={brief.scales.minimalistDense}
            labelLow={SCALE_LABELS.minimalistDense.low}
            labelHigh={SCALE_LABELS.minimalistDense.high}
          />
          <ScaleDisplay
            value={brief.scales.playfulSerious}
            labelLow={SCALE_LABELS.playfulSerious.low}
            labelHigh={SCALE_LABELS.playfulSerious.high}
          />
          <ScaleDisplay
            value={brief.scales.safeExperimental}
            labelLow={SCALE_LABELS.safeExperimental.low}
            labelHigh={SCALE_LABELS.safeExperimental.high}
          />
        </div>
      </div>

      <div className="brief-card__footer">
        <span className="brief-card__id">ID: {brief.id}</span>
      </div>
    </div>
  );
}
